import classnames from 'classnames';
import InfoCircle from 'components/Icons/InfoCircle';
import Chevron from 'components/Icons/Chevron';
import StdListContext from 'contexts/StdListContext';
import React, { MouseEvent } from 'react';

interface Props {
  id?: string;
  text: string;
  field?: string;
  sortCell?: boolean; // If the Cell is a Sort Cell i.e can you sort by it.
  sortColumn?: boolean; // If it's the current column that list is being sorted by.
  leftBorder?: boolean;
  sortDirection?: 'ascending' | 'descending';
  onSortCellClick?: () => void;
  rightText?: string;
  rightTextOnClick?: () => void;
  showIcon?: boolean;
  onIconClick?: () => void;
}

const StdListHeaderCell = (props: Props): React.ReactElement => {
  const {
    id = '',
    text,
    field,
    sortCell,
    sortColumn,
    leftBorder,
    sortDirection,
    onSortCellClick,
    rightText,
    rightTextOnClick,
    showIcon,
    onIconClick = () => {},
  } = props;

  const handleIconClick = (event: MouseEvent) => {
    event.stopPropagation();
    onIconClick();
  };

  return (
    <StdListContext.Consumer>
      {({ id: listId }): React.ReactNode => (
        <div
          id={id.length > 0 ? id : `${listId}-header-cell-${field || text}`}
          onClick={onSortCellClick}
          className={classnames(
            `${listId}-header-cell h100 row items-center pl3`,
            {
              'cursor-pointer': sortCell,
              pl5: text === 'ID',
            }
          )}
          style={{
            borderLeft: leftBorder ? 'solid #e2e2e2 1px' : 'initial',
          }}
        >
          <div className="font-size-2 black-1 truncate">{text || field}</div>
          {showIcon && (
            <div onClick={(event: MouseEvent) => handleIconClick(event)}>
              <InfoCircle />
            </div>
          )}
          {sortCell && sortColumn ? (
            <div className="color-gray-5 row">
              <div className="ws1 ml2 fill-primary-dark">
                <div
                  className="wrem-p5"
                  style={{
                    transform: `rotate(${
                      sortDirection === 'ascending' ? '180deg' : '0deg'
                    })`,
                  }}
                >
                  <Chevron />
                </div>
              </div>
            </div>
          ) : null}
          {rightText !== '' && (
            <div
              id="admin-page-perm-details-link"
              className="black-1 bold font-size-2 cursor-pointer mr2"
              style={{ marginLeft: 'auto' }}
              onClick={rightTextOnClick}
            >
              {rightText}
            </div>
          )}
        </div>
      )}
    </StdListContext.Consumer>
  );
};

export default StdListHeaderCell;
